// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3wFSx","loaderOuter":"PageOverlayLoader_loaderOuter__1se3O"};